export function useOfferExpired() {
    const {t} = useI18n()
    const {$toast} = useNuxtApp()
    let isActive = false

    return refreshAction => {
        if (isActive) return
        $toast.error(t('offers_expired'), {
            showClose: true,
            closeText: t('refresh'),
            closeAction: () => {
                isActive = false
                refreshAction()
            },
        })
        isActive = true
    }
}
